<template>
  <section>
    <el-form :model="formObj" :rules="formRules" ref="formObj" label-width="120px">
      <el-form-item label="项目" v-if="proList.length>0" prop="projectId">
        <el-select v-model="formObj.projectId" placeholder="请选择项目">
          <el-option v-for="(item,index) in proList" :key="item.id" :value="item.id" :label="item.proName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模型名称" prop="modelName">
        <el-input v-model="formObj.modelName" placeholder="请输入名称" maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="建模工具" prop="toolId">
        <el-select v-model="formObj.toolId" placeholder="建模工具">
          <el-option v-for="(item,index) in tools" :key="item.id" :label="item.toolsName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="上传附件" v-if="option!=1">
        <el-row>
          <el-col :span="24">
            <el-upload
              class="upload-demo"
              ref="upload"
              :action="this.GLOBAL.modelServerPath+'/fileupload'"
              :headers="this.GLOBAL.fileHeader"
              name="file"
              :data="formObj"
              :file-list="fileList"
              :limit="1"
              :on-exceed="handleExceed"
              :on-remove="removeConUpload"
              :on-success="successConUpload"
              :before-upload="beforeConUpload"
              :auto-upload="false">
              <el-button slot="trigger" size="small" type="primary">选取模型</el-button>
              <el-button type="success" size="small" @click="doUpload">上传</el-button>
              <div slot="tip" class="el-upload__tip" style="color: red;">只能上传.rar文件,模型文件需用同名文件夹装载打包 如:test.rar= test/test.rvt</div>
            </el-upload>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
    </div>
  </section>
</template>

<script>
  import {proSearch, createModel, updateModel} from '../../api/api'

  export default {
    name: "ModelForm",
    props: {
      option: 0,
      formData: {},
      type: 0
    },
    data() {
      return {
        formObj: {projectId: null},
        formRules: {
          projectId: [
            {required: true, message: '请选择项目', trigger: 'change'}
          ],
          modelName: [
            {required: true, message: '请输入设备名称', trigger: 'blur'}
          ],
          toolId: [
            {required: true, message: '请输入设备名称', trigger: 'change'}
          ],
        },
        fileList: [],
        tools: [{id: 1, toolsName: 'Revit'}],
        proList: [],

      }
    },
    methods: {
      beforeConUpload: function (file) {
        let fileName = file.name;
        let index = fileName.indexOf(".");
        fileName = fileName.substr(index+1, fileName.length);
        if(fileName!='rar'){
          this.$message({
            message: "只能上传.rar文件",
            type: 'error'
          });
        }
      },
      doUpload: function () {
        if (this.formObj.projectId != null) {
          this.$refs.upload.submit();
        } else {
          this.$message({
            message: "请选择项目",
            type: 'error'
          });
        }

      },
      successConUpload: function (response) {
        this.formObj.modelUrl = response.data;

      },
      removeConUpload: function () {
        this.formObj.modelUrl = null;
      },
      //上传限制
      handleExceed: function (files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      doSubmit: function (option) {
        if ((this.formObj.modelUrl == null || this.formObj.modelUrl == '') && this.option != 1) {
          this.$message({
            message: "请上传模型文件",
            type: 'error'
          });
          return false;
        }
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              if (option == 0) {
                createModel(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "添加成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              } else if (option == 1) {
                updateModel(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });
      },
      doCancel: function () {
        this.$emit('doCancel');
      },
    },
    mounted() {
      //初始化表单数据
      this.formObj = this.formData;
      if (this.option == 1) {
        if (this.formObj.modelUrl != null && this.formObj.modelUrl != '') {
          this.fileList.push({url: this.GLOBAL.baseFilePath + '' + this.formObj.modelUrl})
        }
      }
      //加载项目列表 如果 当前用户没有在任何项目  那么 加载 该用户所在公司及下属公司的所有项目
      if (this.GLOBAL.proList.length > 0) {
        this.proList = this.GLOBAL.proList;
      } else {
        let params = {
          page: 1,
          limit: 10000,
          comId: this.GLOBAL.user.comId == '' ? null : this.GLOBAL.user.comId
        };//请求参数
        proSearch(params, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.proList = result.data.result;
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/model/ModelForm.vue